jQuery( '.open-modal' ).on( 'click', function() {
    var id = jQuery( this ).attr( 'modal-id' );

    jQuery( '.modal#' + id ).show();
});

jQuery( '.modal-close' ).on( 'click', function() {
    var id = jQuery( this ).closest( '.modal' ).attr( 'id' );

    jQuery( '#' + id ).hide();
});

jQuery( '.modal .modal-content #modalSlider' ).slick( {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: jQuery( '.modal .modal-content .arrows .prev' ),
    nextArrow: jQuery( '.modal .modal-content .arrows .next' ),
});
